<div class="form-element"
    [ngClass]="{ 'error': form.elements['value'].error.required }">
    <label>{{ translationManager.getTranslation('Тип параметра') }}</label>
    <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
        <select [(ngModel)]="form.elements['value'].value" (change)="valueChange($event.target.value)">
            <option></option>
            <option *ngFor="let option of _model.options" [value]="option.id">{{ translationManager.getTranslation('ParameterType-UniqueIdentifier#' + option.uniqueIdentifier) }}</option>
        </select>
    </div>
    <div class="errors">
        <span *ngIf="form.elements['value'].error.required">
            <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је
            обавезно за
            унос') }}</span>
    </div>
    <div class="content" *ngIf="state === viewState.Details">
        <div class="static">
            <span>{{ form.elements['valueName'].value }}</span>
        </div>
    </div>
</div>